"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePinCode = exports.validatePhoneOwnership = exports.validatePhoneAccessCode = exports.validateEmailPin = exports.validateEmailOwnership = exports.validateEmailMask = exports.updateUserWithSocialUserData = exports.updateUserPhone = exports.updateUserChannel = exports.updateUserAttribute = exports.updateUser = exports.tokenValidationActions = exports.submitAccountForm = exports.socialValidatePinCodeAndCreateAccount = exports.socialValidatePhoneAccessCode = exports.socialSubmitAccountForm = exports.socialSendAccessCode = exports.socialLoginSucceded = exports.socialLoginSendAccessCodeAndRedirect = exports.socialLoginSendAccessCode = exports.socialLoginPhoneMatched = exports.socialLoginFormResubmitted = exports.socialLoginCreateUserPageViewed = exports.socialLoginCreateUserFormSubmitted = exports.setResponse = exports.setFirstVisit = exports.sendPhoneAccessCodeAndRedirect = exports.sendPhoneAccessCode = exports.sendAccessCodeAndRedirect = exports.sendAccessCode = exports.saveRedirectUrl = exports.saveQuery = exports.requestFailureYouAreARobot = exports.requestFailureUserIsBlocked = exports.requestFailureUnknownError = exports.requestFailureSupportNeeded = exports.requestFailureInvalidPhonePin = exports.requestFailureInvalidPhoneNumber = exports.refreshProfile = exports.redirectToPhoneNumberLoginPage = exports.redirectToPhoneConfirmationPage = exports.pinUserAccountProblem = exports.pinPhoneValidated = exports.pinPhoneFormViewed = exports.pinPhoneFormSubmitted = exports.pinPhoneDialogViewed = exports.pinEmailResend = exports.pinEmailFormViewed = exports.pinEmailFormSubmitted = exports.maskEmailFormViewed = exports.maskEmailFormSubmitted = exports.logout = exports.loginUserSocialCredentialMatched = exports.loginUserCreated = exports.loginSucceeded = exports.loginSocialResolverPageViewed = exports.loginSkipClicked = exports.loginPhoneFormViewed = exports.loginPhoneFormSubmitted = exports.loginPageViewed = exports.loginOptionSelected = exports.loginOptionPageViewed = exports.loginOnSubmitButton = exports.loginFormResubmitted = exports.loginFailureInvalidEmailPin = exports.loginFailureInvalidEmailMask = exports.loginEmailValidationCodeViewed = exports.loginEmailValidationCodeSubmitted = exports.loginEmailCodeDeliveryProblem = exports.loginEmailAccountProblem = exports.loginEmailAccountMatchingViewed = exports.loginEmailAccountConfirmed = exports.loginCreateUserPageViewed = exports.loginCreateUserFormSubmitted = exports.loginAddicionalEmailAdded = exports.differentEmailSubmitted = exports.clearUser = exports.clearResponse = exports.clearRequestStatus = exports.beginSocialLogin = exports.beginSocialEmailConfirmation = exports.beginAccountOwnership = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _auth = require("@aws-amplify/auth");
var _user = require("../block-party/api/user");
var _cookie = require("../utils/cookie");
var _routing = require("./routing");
var _actionHelpers = require("./actionHelpers");
var _constants = require("./constants");
var _login = require("../api/login");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var setResponse = function setResponse(_ref) {
  var type = _ref.type,
    status = _ref.status;
  return {
    type: _constants.SET_RESPONSE,
    response: {
      type: type,
      status: status
    }
  };
};
exports.setResponse = setResponse;
var clearResponse = function clearResponse() {
  return {
    type: _constants.CLEAR_RESPONSE
  };
};
exports.clearResponse = clearResponse;
var clearRequestStatus = function clearRequestStatus() {
  return {
    type: _constants.CLEAR_REQUEST_STATUS
  };
};
exports.clearRequestStatus = clearRequestStatus;
var loginPageViewed = function loginPageViewed() {
  return {
    type: _constants.LOGIN_PAGE_VIEWED
  };
};
exports.loginPageViewed = loginPageViewed;
var loginOptionPageViewed = function loginOptionPageViewed() {
  return {
    type: _constants.LOGIN_OPTION_PAGE_VIEWED
  };
};
exports.loginOptionPageViewed = loginOptionPageViewed;
var loginOptionSelected = function loginOptionSelected(provider) {
  return {
    type: _constants.LOGIN_OPTION_SELECTED,
    provider: provider
  };
};
exports.loginOptionSelected = loginOptionSelected;
var loginSocialResolverPageViewed = function loginSocialResolverPageViewed() {
  return {
    type: _constants.LOGIN_SOCIAL_RESOLVER_PAGE_VIEWED
  };
};
exports.loginSocialResolverPageViewed = loginSocialResolverPageViewed;
var loginEmailAccountMatchingViewed = function loginEmailAccountMatchingViewed() {
  return {
    type: _constants.LOGIN_EMAIL_ACCOUNT_MATCHING
  };
};
exports.loginEmailAccountMatchingViewed = loginEmailAccountMatchingViewed;
var loginEmailAccountConfirmed = function loginEmailAccountConfirmed() {
  return {
    type: _constants.LOGIN_EMAIL_MATCHING_CONFIRMED
  };
};
exports.loginEmailAccountConfirmed = loginEmailAccountConfirmed;
var loginEmailAccountProblem = function loginEmailAccountProblem() {
  return {
    type: _constants.LOGIN_EMAIL_ACCOUNT_PROBLEM
  };
};
exports.loginEmailAccountProblem = loginEmailAccountProblem;
var loginAddicionalEmailAdded = function loginAddicionalEmailAdded() {
  return {
    type: _constants.LOGIN_ADDICIONAL_EMAIL_ADDED
  };
};
exports.loginAddicionalEmailAdded = loginAddicionalEmailAdded;
var loginEmailValidationCodeViewed = function loginEmailValidationCodeViewed() {
  return {
    type: _constants.LOGIN_EMAIL_VALIDATION_CODE_VIEWED
  };
};
exports.loginEmailValidationCodeViewed = loginEmailValidationCodeViewed;
var loginEmailValidationCodeSubmitted = function loginEmailValidationCodeSubmitted() {
  return {
    type: _constants.LOGIN_EMAIL_VALIDATION_CODE_SUBMITTED
  };
};
exports.loginEmailValidationCodeSubmitted = loginEmailValidationCodeSubmitted;
var loginEmailCodeDeliveryProblem = function loginEmailCodeDeliveryProblem() {
  return {
    type: _constants.LOGIN_EMAIL_CODE_DELIVERY_PROBLEM
  };
};
exports.loginEmailCodeDeliveryProblem = loginEmailCodeDeliveryProblem;
var loginPhoneFormViewed = function loginPhoneFormViewed() {
  return {
    type: _constants.LOGIN_PHONE_FORM_VIEWED
  };
};
exports.loginPhoneFormViewed = loginPhoneFormViewed;
var loginPhoneFormSubmitted = function loginPhoneFormSubmitted() {
  return {
    type: _constants.LOGIN_PHONE_FORM_SUBMITTED
  };
};
exports.loginPhoneFormSubmitted = loginPhoneFormSubmitted;
var loginSkipClicked = function loginSkipClicked() {
  return {
    type: _constants.LOGIN_SKIP_CLICKED
  };
};
exports.loginSkipClicked = loginSkipClicked;
var loginCreateUserPageViewed = function loginCreateUserPageViewed() {
  return {
    type: _constants.LOGIN_CREATE_USER_PAGE_VIEWED
  };
};
exports.loginCreateUserPageViewed = loginCreateUserPageViewed;
var socialLoginCreateUserPageViewed = function socialLoginCreateUserPageViewed() {
  return {
    type: _constants.SOCIAL_LOGIN_CREATE_USER_PAGE_VIEWED
  };
};
exports.socialLoginCreateUserPageViewed = socialLoginCreateUserPageViewed;
var pinPhoneFormViewed = function pinPhoneFormViewed() {
  return {
    type: _constants.PIN_PHONE_FORM_VIEWED
  };
};
exports.pinPhoneFormViewed = pinPhoneFormViewed;
var pinPhoneFormSubmitted = function pinPhoneFormSubmitted() {
  return {
    type: _constants.PIN_PHONE_FORM_SUBMITTED
  };
};
exports.pinPhoneFormSubmitted = pinPhoneFormSubmitted;
var pinPhoneDialogViewed = function pinPhoneDialogViewed() {
  return {
    type: _constants.PIN_PHONE_DIALOG_VIEWED
  };
};
exports.pinPhoneDialogViewed = pinPhoneDialogViewed;
var pinUserAccountProblem = function pinUserAccountProblem() {
  return {
    type: _constants.PIN_USER_ACCOUNT_PROBLEM
  };
};
exports.pinUserAccountProblem = pinUserAccountProblem;
var pinPhoneValidated = function pinPhoneValidated(properties) {
  return {
    type: _constants.PIN_PHONE_VALIDATED,
    properties: properties
  };
};
exports.pinPhoneValidated = pinPhoneValidated;
var maskEmailFormViewed = function maskEmailFormViewed() {
  return {
    type: _constants.MASK_EMAIL_FORM_VIEWED
  };
};
exports.maskEmailFormViewed = maskEmailFormViewed;
var maskEmailFormSubmitted = function maskEmailFormSubmitted() {
  return {
    type: _constants.MASK_EMAIL_FORM_SUBMITTED
  };
};
exports.maskEmailFormSubmitted = maskEmailFormSubmitted;
var differentEmailSubmitted = function differentEmailSubmitted() {
  return {
    type: _constants.DIFFERENT_EMAIL_SUBMITTED
  };
};
exports.differentEmailSubmitted = differentEmailSubmitted;
var pinEmailFormViewed = function pinEmailFormViewed() {
  return {
    type: _constants.PIN_EMAIL_FORM_VIEWED
  };
};
exports.pinEmailFormViewed = pinEmailFormViewed;
var pinEmailFormSubmitted = function pinEmailFormSubmitted() {
  return {
    type: _constants.PIN_EMAIL_FORM_SUBMITTED
  };
};
exports.pinEmailFormSubmitted = pinEmailFormSubmitted;
var pinEmailResend = function pinEmailResend() {
  return {
    type: _constants.PIN_EMAIL_RESEND
  };
};
exports.pinEmailResend = pinEmailResend;
var loginCreateUserFormSubmitted = function loginCreateUserFormSubmitted() {
  return {
    type: _constants.LOGIN_CREATE_USER_FORM_SUBMITTED
  };
};
exports.loginCreateUserFormSubmitted = loginCreateUserFormSubmitted;
var socialLoginCreateUserFormSubmitted = function socialLoginCreateUserFormSubmitted() {
  return {
    type: _constants.SOCIAL_LOGIN_CREATE_USER_FORM_SUBMITTED
  };
};
exports.socialLoginCreateUserFormSubmitted = socialLoginCreateUserFormSubmitted;
var loginSucceeded = function loginSucceeded(loginData, flow) {
  return {
    type: _constants.LOGIN_SUCCESS,
    loginData: loginData,
    flow: flow
  };
};
exports.loginSucceeded = loginSucceeded;
var socialLoginSucceded = function socialLoginSucceded(loginData, provider, flow) {
  return {
    type: _constants.SOCIAL_LOGIN_SUCCESS,
    loginData: loginData,
    provider: provider,
    flow: flow
  };
};
exports.socialLoginSucceded = socialLoginSucceded;
var loginUserCreated = function loginUserCreated(email) {
  var isFromUserCreatedFlux = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    type: _constants.LOGIN_USER_CREATED,
    created: isFromUserCreatedFlux,
    email: email,
    params: params
  };
};
exports.loginUserCreated = loginUserCreated;
var loginUserSocialCredentialMatched = function loginUserSocialCredentialMatched(data) {
  return {
    type: _constants.LOGIN_SOCIAL_CREDENTIAL_MATCHED,
    data: data
  };
};
exports.loginUserSocialCredentialMatched = loginUserSocialCredentialMatched;
var socialLoginPhoneMatched = function socialLoginPhoneMatched(data) {
  return {
    type: _constants.LOGIN_SOCIAL_PHONE_MATCHED,
    data: data
  };
};
exports.socialLoginPhoneMatched = socialLoginPhoneMatched;
var requestFailureInvalidPhoneNumber = function requestFailureInvalidPhoneNumber() {
  return {
    type: _constants.REQUEST_FAILURE_INVALID_PHONE_NUMBER
  };
};
exports.requestFailureInvalidPhoneNumber = requestFailureInvalidPhoneNumber;
var requestFailureInvalidPhonePin = function requestFailureInvalidPhonePin() {
  return {
    type: _constants.REQUEST_FAILURE_INVALID_PHONE_PIN
  };
};
exports.requestFailureInvalidPhonePin = requestFailureInvalidPhonePin;
var requestFailureUnknownError = function requestFailureUnknownError() {
  return {
    type: _constants.REQUEST_FAILURE_UNKNOWN_ERROR
  };
};
exports.requestFailureUnknownError = requestFailureUnknownError;
var requestFailureYouAreARobot = function requestFailureYouAreARobot() {
  return {
    type: _constants.REQUEST_FAILURE_YOU_ARE_A_ROBOT
  };
};
exports.requestFailureYouAreARobot = requestFailureYouAreARobot;
var requestFailureUserIsBlocked = function requestFailureUserIsBlocked() {
  return {
    type: _constants.REQUEST_FAILURE_USER_IS_BLOCKED
  };
};
exports.requestFailureUserIsBlocked = requestFailureUserIsBlocked;
var requestFailureSupportNeeded = function requestFailureSupportNeeded() {
  return {
    type: _constants.REQUEST_FAILURE_SUPPORT_NEEDED
  };
};
exports.requestFailureSupportNeeded = requestFailureSupportNeeded;
var loginFailureInvalidEmailPin = function loginFailureInvalidEmailPin() {
  return {
    type: _constants.LOGIN_FAILURE_INVALID_EMAIL_PIN
  };
};
exports.loginFailureInvalidEmailPin = loginFailureInvalidEmailPin;
var loginFailureInvalidEmailMask = function loginFailureInvalidEmailMask() {
  return {
    type: _constants.LOGIN_FAILURE_INVALID_EMAIL_MASK
  };
};
exports.loginFailureInvalidEmailMask = loginFailureInvalidEmailMask;
var tokenValidationActions = {
  phonePin: requestFailureInvalidPhonePin(),
  emailPin: loginFailureInvalidEmailPin(),
  emailMask: loginFailureInvalidEmailMask()
};
exports.tokenValidationActions = tokenValidationActions;
var updateUserChannel = function updateUserChannel(channel) {
  return function (dispatch) {
    dispatch({
      type: _constants.UPDATE_USER_CHANNEL,
      channel: channel
    });
  };
};
exports.updateUserChannel = updateUserChannel;
var socialLoginSendAccessCode = function socialLoginSendAccessCode(_ref2) {
  var internationalPhoneNumber = _ref2.internationalPhoneNumber,
    channel = _ref2.channel,
    captchaToken = _ref2.captchaToken,
    onSuccess = _ref2.onSuccess;
  return function (dispatch) {
    return dispatch({
      type: _constants.SOCIAL_LOGIN_SEND_ACCESS_CODE,
      promise: (0, _login.socialPhoneConfirmationStart)({
        phone: internationalPhoneNumber,
        channel: channel,
        captchaToken: captchaToken
      }),
      meta: {
        onSuccess: onSuccess,
        onFailure: (0, _actionHelpers.handleSocialLoginRequestFailure)(clearUser, dispatch)
      }
    });
  };
};
exports.socialLoginSendAccessCode = socialLoginSendAccessCode;
var sendPhoneAccessCode = function sendPhoneAccessCode(_ref3) {
  var internationalPhoneNumber = _ref3.internationalPhoneNumber,
    channel = _ref3.channel,
    captchaToken = _ref3.captchaToken,
    onSuccess = _ref3.onSuccess,
    sessionId = _ref3.sessionId,
    captchaProvider = _ref3.captchaProvider;
  return function (dispatch) {
    return dispatch({
      type: _constants.SEND_ACCESS_CODE,
      promise: (0, _login.phoneConfirmationStart)({
        phone: internationalPhoneNumber,
        sessionId: sessionId,
        channel: channel,
        captchaToken: captchaToken,
        captchaProvider: captchaProvider
      }),
      meta: {
        onSuccess: onSuccess,
        onFailure: (0, _actionHelpers.handleRequestFailure)(clearUser, dispatch)
      }
    });
  };
};
exports.sendPhoneAccessCode = sendPhoneAccessCode;
var sendAccessCode = function sendAccessCode(_ref4) {
  var phone = _ref4.phone,
    sessionId = _ref4.sessionId,
    channel = _ref4.channel,
    captchaToken = _ref4.captchaToken,
    captchaProvider = _ref4.captchaProvider,
    onSuccess = _ref4.onSuccess;
  return function (dispatch) {
    var formattedCountryCode = phone.countryCode.startsWith("+") ? phone.countryCode : "+".concat(phone.countryCode);
    var formattedPhone = "".concat(formattedCountryCode).concat(phone.areaCode).concat(phone.phoneNumber);
    dispatch({
      type: _constants.SEND_ACCESS_CODE,
      promise: (0, _login.phoneConfirmationStart)({
        phone: formattedPhone,
        sessionId: sessionId,
        channel: channel,
        captchaToken: captchaToken,
        captchaProvider: captchaProvider
      }),
      meta: {
        onSuccess: onSuccess,
        onFailure: (0, _actionHelpers.handleRequestFailure)(clearUser, dispatch)
      }
    });
  };
};
exports.sendAccessCode = sendAccessCode;
var socialSendAccessCode = function socialSendAccessCode(_ref5) {
  var phone = _ref5.phone,
    sessionId = _ref5.sessionId,
    channel = _ref5.channel,
    captchaToken = _ref5.captchaToken,
    onSuccess = _ref5.onSuccess,
    currentState = _ref5.currentState;
  return function (dispatch) {
    var formattedCountryCode = phone.countryCode.startsWith("+") ? phone.countryCode : "+".concat(phone.countryCode);
    var formattedPhone = "".concat(formattedCountryCode).concat(phone.areaCode).concat(phone.phoneNumber);
    dispatch({
      type: _constants.SEND_ACCESS_CODE,
      promise: (0, _login.socialPhoneConfirmationStart)({
        phone: formattedPhone,
        sessionId: sessionId,
        channel: channel,
        captchaToken: captchaToken,
        currentState: currentState
      }),
      meta: {
        onSuccess: onSuccess,
        onFailure: (0, _actionHelpers.handleRequestFailure)(clearUser, dispatch)
      }
    });
  };
};
exports.socialSendAccessCode = socialSendAccessCode;
var sendAccessCodeAndRedirect = function sendAccessCodeAndRedirect(_ref6) {
  var phone = _ref6.phone,
    sessionId = _ref6.sessionId,
    channel = _ref6.channel,
    captchaToken = _ref6.captchaToken,
    captchaProvider = _ref6.captchaProvider;
  return function (dispatch) {
    var onSuccess = (0, _routing.goToAccessCodePage)(dispatch);
    sendAccessCode({
      phone: phone,
      sessionId: sessionId,
      channel: channel,
      captchaToken: captchaToken,
      captchaProvider: captchaProvider,
      onSuccess: onSuccess
    })(dispatch);
  };
};
exports.sendAccessCodeAndRedirect = sendAccessCodeAndRedirect;
var sendPhoneAccessCodeAndRedirect = function sendPhoneAccessCodeAndRedirect(_ref7) {
  var internationalPhoneNumber = _ref7.internationalPhoneNumber,
    sessionId = _ref7.sessionId,
    channel = _ref7.channel,
    captchaToken = _ref7.captchaToken,
    captchaProvider = _ref7.captchaProvider;
  return function (dispatch) {
    var onSuccess = (0, _routing.goToAccessCodePage)(dispatch);
    sendPhoneAccessCode({
      internationalPhoneNumber: internationalPhoneNumber,
      sessionId: sessionId,
      channel: channel,
      captchaToken: captchaToken,
      captchaProvider: captchaProvider,
      onSuccess: onSuccess
    })(dispatch);
  };
};
exports.sendPhoneAccessCodeAndRedirect = sendPhoneAccessCodeAndRedirect;
var socialLoginSendAccessCodeAndRedirect = function socialLoginSendAccessCodeAndRedirect(_ref8) {
  var internationalPhoneNumber = _ref8.internationalPhoneNumber,
    channel = _ref8.channel,
    captchaToken = _ref8.captchaToken;
  return function (dispatch) {
    var onSuccess = (0, _routing.goToSocialAcessCodePage)(dispatch);
    socialLoginSendAccessCode({
      internationalPhoneNumber: internationalPhoneNumber,
      channel: channel,
      captchaToken: captchaToken,
      onSuccess: onSuccess
    })(dispatch);
  };
};
exports.socialLoginSendAccessCodeAndRedirect = socialLoginSendAccessCodeAndRedirect;
var validatePhoneAccessCode = function validatePhoneAccessCode(_ref9) {
  var sessionId = _ref9.sessionId,
    token = _ref9.token,
    redirectUrl = _ref9.redirectUrl,
    clearUser = _ref9.clearUser,
    riskAssessmentToken = _ref9.riskAssessmentToken;
  return function (dispatch) {
    dispatch({
      type: _constants.VALIDATE_PHONE_ACCESS_CODE,
      promise: (0, _login.tokenValidatePhonePin)({
        sessionId: sessionId,
        token: token,
        riskAssessmentToken: riskAssessmentToken
      }),
      meta: {
        onSuccess: (0, _actionHelpers.validatePhoneAccessOnSuccess)(redirectUrl, dispatch),
        onFailure: (0, _actionHelpers.handleRequestFailure)(clearUser, dispatch, {
          type: _constants.PHONE_PIN_ERROR
        })
      }
    });
  };
};
exports.validatePhoneAccessCode = validatePhoneAccessCode;
var socialValidatePhoneAccessCode = function socialValidatePhoneAccessCode(_ref10) {
  var sessionId = _ref10.sessionId,
    token = _ref10.token,
    clearUser = _ref10.clearUser;
  return function (dispatch) {
    dispatch({
      type: _constants.SOCIAL_VALIDATE_PHONE_ACCESS_CODE,
      promise: (0, _login.socialTokenValidatePhonePin)({
        sessionId: sessionId,
        token: token
      }),
      meta: {
        onSuccess: (0, _actionHelpers.socialValidatePhoneAccessOnSuccess)(dispatch),
        onFailure: (0, _actionHelpers.handleSocialLoginRequestFailure)(clearUser, dispatch, {
          type: _constants.PHONE_PIN_ERROR
        })
      }
    });
  };
};
exports.socialValidatePhoneAccessCode = socialValidatePhoneAccessCode;
var socialValidatePinCodeAndCreateAccount = function socialValidatePinCodeAndCreateAccount(_ref11) {
  var requestPayload = _ref11.requestPayload,
    provider = _ref11.provider,
    redirectUrl = _ref11.redirectUrl;
  return function (dispatch) {
    dispatch({
      type: _constants.SOCIAL_VALIDATE_AND_CREATE_ACCOUNT,
      promise: (0, _login.socialValidateAndCreateAccount)(_objectSpread({}, requestPayload)),
      meta: {
        onSuccess: (0, _actionHelpers.socialValidateAndAccountCreateOnSuccess)(dispatch, requestPayload.email, provider, redirectUrl),
        onFailure: (0, _actionHelpers.handleSocialLoginRequestFailure)(clearUser, dispatch, {
          type: _constants.PHONE_PIN_ERROR
        })
      }
    });
  };
};
exports.socialValidatePinCodeAndCreateAccount = socialValidatePinCodeAndCreateAccount;
var validatePinCode = function validatePinCode(_ref12) {
  var sessionId = _ref12.sessionId,
    token = _ref12.token,
    onSuccess = _ref12.onSuccess,
    onFailure = _ref12.onFailure;
  return function (dispatch) {
    dispatch({
      type: _constants.VALIDATE_PIN_CODE,
      promise: (0, _login.tokenValidateIdentityPin)({
        sessionId: sessionId,
        token: token
      }),
      meta: {
        onSuccess: onSuccess,
        onFailure: onFailure
      }
    });
  };
};
exports.validatePinCode = validatePinCode;
var validateEmailMask = function validateEmailMask(_ref13) {
  var sessionId = _ref13.sessionId,
    email = _ref13.email,
    redirectUrl = _ref13.redirectUrl,
    riskAssessmentToken = _ref13.riskAssessmentToken;
  return function (dispatch) {
    dispatch({
      type: _constants.VALIDATE_EMAIL_MASK,
      promise: (0, _login.tokenValidateEmailMask)({
        sessionId: sessionId,
        email: email,
        riskAssessmentToken: riskAssessmentToken
      }),
      meta: {
        onSuccess: (0, _actionHelpers.onValidationSuccess)(redirectUrl, dispatch, _constants.LOGIN_FLOW.PHONE_WITH_MASKED_EMAIL_VALIDATION),
        onFailure: (0, _actionHelpers.handleRequestFailure)(clearUser, dispatch, {
          type: _constants.EMAIL_MASK
        })
      }
    });
  };
};
exports.validateEmailMask = validateEmailMask;
var validateEmailPin = function validateEmailPin(_ref14) {
  var sessionId = _ref14.sessionId,
    token = _ref14.token,
    redirectUrl = _ref14.redirectUrl,
    clearUser = _ref14.clearUser,
    riskAssessmentToken = _ref14.riskAssessmentToken;
  return function (dispatch) {
    dispatch({
      type: _constants.VALIDATE_EMAIL_PIN,
      promise: (0, _login.tokenValidateEmailPin)({
        sessionId: sessionId,
        token: token,
        riskAssessmentToken: riskAssessmentToken
      }),
      meta: {
        onSuccess: (0, _actionHelpers.onValidationSuccess)(redirectUrl, dispatch, _constants.LOGIN_FLOW.PHONE_WITH_EMAIL_PIN_VALIDATION),
        onFailure: (0, _actionHelpers.handleRequestFailure)(clearUser, dispatch, {
          type: _constants.EMAIL_PIN_ERROR
        })
      }
    });
  };
};
exports.validateEmailPin = validateEmailPin;
var submitAccountForm = function submitAccountForm(payload) {
  return function (dispatch) {
    dispatch({
      type: _constants.SUBMIT_ACCOUNT_FORM,
      promise: (0, _login.emailConfirmationStart)(payload),
      meta: {
        payload: payload,
        onSuccess: (0, _actionHelpers.onSubmitAccountFormSuccess)(payload.redirectUrl, payload.onSuccess, dispatch),
        onFailure: (0, _actionHelpers.handleRequestFailure)(payload.clearUser, dispatch)
      }
    });
  };
};
exports.submitAccountForm = submitAccountForm;
var socialSubmitAccountForm = function socialSubmitAccountForm(payload) {
  return function (dispatch) {
    dispatch({
      type: _constants.SOCIAL_SUBMIT_ACCOUNT_FORM,
      promise: (0, _login.socialCreateAccount)(payload),
      meta: {
        payload: payload,
        onSuccess: (0, _actionHelpers.onSocialSubmitAccountFormSuccess)(payload.redirectUrl, dispatch, payload.provider),
        onFailure: (0, _actionHelpers.handleRequestFailure)(payload.clearUser, dispatch)
      }
    });
  };
};
exports.socialSubmitAccountForm = socialSubmitAccountForm;
var beginSocialLogin = function beginSocialLogin(payload) {
  return function (dispatch) {
    dispatch({
      type: _constants.BEGIN_SOCIAL_LOGIN,
      promise: (0, _login.beginSocialLogin)(payload),
      meta: {
        payload: payload,
        onSuccess: (0, _actionHelpers.onBeginSocialLoginSuccess)(payload.redirectUrl, dispatch, payload.provider),
        onFailure: (0, _actionHelpers.handleSocialLoginRequestFailure)(payload.clearUser, dispatch)
      }
    });
  };
};
exports.beginSocialLogin = beginSocialLogin;
var beginAccountOwnership = function beginAccountOwnership(_ref15) {
  var sessionToken = _ref15.sessionToken,
    channel = _ref15.channel;
  return function (dispatch) {
    dispatch({
      type: _constants.BEGIN_ACCOUNT_OWNERSHIP,
      promise: (0, _login.beginAccountOwnership)({
        sessionToken: sessionToken,
        channel: channel
      })
    });
  };
};
exports.beginAccountOwnership = beginAccountOwnership;
var validatePhoneOwnership = function validatePhoneOwnership(_ref16) {
  var sessionId = _ref16.sessionId,
    pinCode = _ref16.pinCode,
    redirectUrl = _ref16.redirectUrl,
    clearUser = _ref16.clearUser,
    accessToken = _ref16.accessToken,
    provider = _ref16.provider;
  return function (dispatch) {
    dispatch({
      type: _constants.VALIDATE_PHONE_OWNERSHIP,
      promise: (0, _login.validateOwnership)({
        sessionId: sessionId,
        pinCode: pinCode,
        accessToken: accessToken,
        type: _constants.PHONE_PIN
      }),
      meta: {
        onSuccess: (0, _actionHelpers.socialValidatePhoneOwnershipOnSuccess)(redirectUrl, dispatch, provider),
        onFailure: (0, _actionHelpers.handleSocialLoginRequestFailure)(clearUser, dispatch, {
          type: _constants.PHONE_PIN_ERROR
        })
      }
    });
  };
};
exports.validatePhoneOwnership = validatePhoneOwnership;
var validateEmailOwnership = function validateEmailOwnership(_ref17) {
  var sessionId = _ref17.sessionId,
    pinCode = _ref17.pinCode,
    clearUser = _ref17.clearUser,
    accessToken = _ref17.accessToken,
    provider = _ref17.provider;
  return function (dispatch) {
    dispatch({
      type: _constants.VALIDATE_EMAIL_OWNERSHIP,
      promise: (0, _login.validateOwnership)({
        sessionId: sessionId,
        pinCode: pinCode,
        accessToken: accessToken,
        type: _constants.EMAIL_PIN
      }),
      meta: {
        onSuccess: (0, _actionHelpers.socialValidateEmailOwnershipOnSuccess)(dispatch, provider),
        onFailure: (0, _actionHelpers.handleSocialLoginRequestFailure)(clearUser, dispatch, {
          type: _constants.EMAIL_PIN_ERROR
        })
      }
    });
  };
};
exports.validateEmailOwnership = validateEmailOwnership;
var beginSocialEmailConfirmation = function beginSocialEmailConfirmation(_ref18) {
  var sessionToken = _ref18.sessionToken,
    clearUser = _ref18.clearUser;
  return function (dispatch) {
    dispatch({
      type: _constants.BEGIN_SOCIAL_EMAIL_CONFIRMATION,
      promise: (0, _login.beginSocialEmailConfirmation)({
        sessionToken: sessionToken
      }),
      meta: {
        onSuccess: (0, _actionHelpers.socialEmailConfirmationOnSuccess)(dispatch),
        onFailure: (0, _actionHelpers.handleSocialLoginRequestFailure)(clearUser, dispatch)
      }
    });
  };
};
exports.beginSocialEmailConfirmation = beginSocialEmailConfirmation;
var redirectToPhoneNumberLoginPage = function redirectToPhoneNumberLoginPage() {
  return function (dispatch) {
    (0, _routing.goToPhoneNumberLoginPage)(dispatch)();
  };
};
exports.redirectToPhoneNumberLoginPage = redirectToPhoneNumberLoginPage;
var redirectToPhoneConfirmationPage = function redirectToPhoneConfirmationPage() {
  return function (dispatch) {
    (0, _routing.goToPhoneConfirmationPage)(dispatch)();
  };
};
exports.redirectToPhoneConfirmationPage = redirectToPhoneConfirmationPage;
var setFirstVisit = function setFirstVisit(value) {
  return {
    type: _constants.SET_FIRST_VISIT,
    value: value
  };
};
exports.setFirstVisit = setFirstVisit;
var refreshProfile = function refreshProfile(endpoint) {
  return {
    type: _constants.REFRESH_PROFILE,
    promise: (0, _user.fetchUser)(endpoint)
  };
};
exports.refreshProfile = refreshProfile;
var updateUser = function updateUser(value) {
  return {
    type: _constants.UPDATE_USER,
    value: value
  };
};
exports.updateUser = updateUser;
var updateUserAttribute = function updateUserAttribute(attr, value) {
  return {
    type: _constants.UPDATE_USER_ATTRIBUTE,
    attr: attr,
    value: value
  };
};
exports.updateUserAttribute = updateUserAttribute;
var updateUserWithSocialUserData = function updateUserWithSocialUserData(userData) {
  return {
    type: _constants.UPDATE_USER_WITH_SOCIAL_USER_DATA,
    userData: userData
  };
};
exports.updateUserWithSocialUserData = updateUserWithSocialUserData;
var updateUserPhone = function updateUserPhone(key, value) {
  return {
    type: _constants.UPDATE_USER_PHONE,
    key: key,
    value: value
  };
};
exports.updateUserPhone = updateUserPhone;
var saveRedirectUrl = function saveRedirectUrl(value) {
  return {
    type: _constants.SAVE_REDIRECT_URL,
    value: value
  };
};
exports.saveRedirectUrl = saveRedirectUrl;
var saveQuery = function saveQuery(value) {
  return {
    type: _constants.SAVE_QUERY,
    value: value
  };
};
exports.saveQuery = saveQuery;
var loginOnSubmitButton = function loginOnSubmitButton() {
  return {
    type: _constants.LOGIN_ON_SUBMIT_BUTTON
  };
};
exports.loginOnSubmitButton = loginOnSubmitButton;
var loginFormResubmitted = function loginFormResubmitted() {
  return {
    type: _constants.LOGIN_FORM_RESUBMITTED
  };
};
exports.loginFormResubmitted = loginFormResubmitted;
var socialLoginFormResubmitted = function socialLoginFormResubmitted() {
  return {
    type: _constants.SOCIAL_LOGIN_FORM_RESUBMITTED
  };
};
exports.socialLoginFormResubmitted = socialLoginFormResubmitted;
var clearUser = function clearUser() {
  return {
    type: _constants.CLEAR_USER
  };
};
exports.clearUser = clearUser;
var logout = function () {
  var _ref19 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
    var qaDomain,
      signOutSocial,
      _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            qaDomain = _args.length > 0 && _args[0] !== undefined ? _args[0] : ".quintoandar.com.br";
            signOutSocial = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
            _context.next = 4;
            return (0, _login.callGandalfLogout)(qaDomain);
          case 4:
            (0, _cookie.clearListCookies)(qaDomain);
            if (!signOutSocial) {
              _context.next = 8;
              break;
            }
            _context.next = 8;
            return _auth.Auth.signOut();
          case 8:
            return _context.abrupt("return", {
              type: _constants.LOGOUT
            });
          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function logout() {
    return _ref19.apply(this, arguments);
  };
}();
exports.logout = logout;